import { z } from 'zod';
import { uuid, isoTimestamp } from './common.js';
/**
 * API §2. No registration endpoint — both accounts are seeded by hand
 * (ARCHITECTURE §12). Sessions are long-lived: a household app that logs you
 * out in a supermarket is broken.
 */
export const loginRequest = z.object({
    email: z.string().email(),
    password: z.string().min(1),
});
export const userDto = z.object({
    id: uuid,
    email: z.string(),
    display_name: z.string(),
});
export const meResponse = z.object({
    user: userDto,
    household: z.object({ id: uuid, name: z.string() }),
    members: z.array(userDto),
});
/**
 * Device registration carries the Web Push subscription. `device_id` is
 * client-generated and stable per install; every request repeats it in the
 * X-Device-Id header, and the server stamps `updated_by_device` from it.
 */
export const registerDeviceRequest = z.object({
    device_id: z.string().min(1).max(200),
    label: z.string().max(200).nullish(),
    push: z
        .object({
        endpoint: z.string().url(),
        keys: z.object({ p256dh: z.string(), auth: z.string() }),
    })
        .nullish(),
});
export const sessionDto = z.object({
    id: uuid,
    user_id: uuid,
    expires_at: isoTimestamp,
});
//# sourceMappingURL=auth.js.map